import actionTypes from '../actions/actionsFactory/types';

const { FETCH_COUNTRY_WHITELIST_SUCCESS } = actionTypes;

export const INITIAL_STATE = {
  countryWhitelist: [],
};

export const reducer = (state, action) => {
  switch (action.type) {
    case FETCH_COUNTRY_WHITELIST_SUCCESS:
      return { ...state, countryWhitelist: [...action.data] };

    default:
      return state;
  }
};
